"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg24EyeHiddenFill = function Svg24EyeHiddenFill(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.293 1.293a1 1 0 0 1 1.414 0l4.685 4.685A11.394 11.394 0 0 1 12 5c4.418 0 8.286 2.57 10.836 6.45a1 1 0 0 1 0 1.1c-1.2 1.825-2.692 3.361-4.396 4.476l4.267 4.267a1 1 0 0 1-1.414 1.414l-.5-.5-4.185-4.185-2.212-2.212-1.482-1.482-3.242-3.242L8.19 9.604l-2.63-2.63-3.767-3.767-.5-.5a1 1 0 0 1 0-1.414zm2.729 6.85a16.196 16.196 0 0 0-2.858 3.308 1 1 0 0 0 0 1.098C3.714 16.43 7.582 19 12 19c.884 0 1.746-.103 2.58-.299l-2.216-2.216a4.5 4.5 0 0 1-4.85-4.85L4.023 8.144zm5.582.047l1.482 1.482a2.5 2.5 0 0 1 3.241 3.241l1.483 1.483A4.5 4.5 0 0 0 9.604 8.19z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg24EyeHiddenFill.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg24EyeHiddenFill;
exports.default = _default;